/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://5p0omefnge.execute-api.eu-west-1.amazonaws.com/uat",
            "region": "eu-west-1"
        },
        {
            "name": "FileValidationService",
            "endpoint": "https://b24w5n9n9e.execute-api.eu-west-1.amazonaws.com/uat",
            "region": "eu-west-1"
        },
        {
            "name": "S3BucketService",
            "endpoint": "https://jinaytfh10.execute-api.eu-west-1.amazonaws.com/uat",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:007054d8-a0c2-4fe5-a28c-eb6a9930a372",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_9EwdvJiH4",
    "aws_user_pools_web_client_id": "2un1sq73fn6kslabctg885o3re",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "uat-datapulse-mmscan",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
